import { createCustomIcon } from "components/primitives";

import { ReactComponent as BoggleSVG } from "./Icon_ToolBar_Boggle.svg";
import { ReactComponent as CalendarSVG } from "./Icon_ToolBar_Calendar.svg";
import { ReactComponent as CartesianSVG } from "./Icon_ToolBar_Cartesian.svg";
import { ReactComponent as ClockSVG } from "./Icon_ToolBar_Clock.svg";
import { ReactComponent as DiceSVG } from "./Icon_ToolBar_DiceRoller.svg";
import { ReactComponent as EmbedSVG } from "./Icon_ToolBar_Embed.svg";
import { ReactComponent as FlashCardsSVG } from "./Icon_ToolBar_FlashCards.svg";
import { ReactComponent as FreeTextSVG } from "./Icon_ToolBar_FreeText.svg";
import { ReactComponent as GoogleSlidesSVG } from "./Icon_ToolBar_GoogleSlides.svg";
import { ReactComponent as HundredsChartSVG } from "./Icon_ToolBar_HundredsChart.svg";
import { ReactComponent as ImageSVG } from "./Icon_ToolBar_Image.svg";
import { ReactComponent as MABSVG } from "./Icon_ToolBar_MABs.svg";
import { ReactComponent as Money } from "./Icon_ToolBar_Money.svg";
import { ReactComponent as NameGeneratorSVG } from "./Icon_ToolBar_NameGenerator.svg";
import { ReactComponent as NoggleSVG } from "./Icon_ToolBar_Noggle.svg";
import { ReactComponent as NoiseMeterSVG } from "./Icon_ToolBar_NoiseMeter.svg";
import { ReactComponent as NumberLineSVG } from "./Icon_ToolBar_NumberLine.svg";
import { ReactComponent as PlaceValueMatSVG } from "./Icon_ToolBar_PlaceValueMat.svg";
import { ReactComponent as ScheduleSVG } from "./Icon_ToolBar_Schedule.svg";
import { ReactComponent as SpinWheelSVG } from "./Icon_ToolBar_SpinWheel.svg";
import { ReactComponent as StopwatchSVG } from "./Icon_ToolBar_Stopwatch.svg";
import { ReactComponent as TimerSVG } from "./Icon_ToolBar_Timer.svg";
import { ReactComponent as WellnessCheckinSVG } from "./Icon_ToolBar_WellnessCheckIn.svg";
import { ReactComponent as WordBuilderSVG } from "./Icon_ToolBar_WordBuilder.svg";
import { ReactComponent as YoutubeSVG } from "./Icon_Toolbar_Youtube.svg";

export const Calendar = createCustomIcon(CalendarSVG, "Calendar");
export const Clock = createCustomIcon(ClockSVG, "Clock");
export const DiceWidget = createCustomIcon(DiceSVG, "DiceWidget");
export const FlashCards = createCustomIcon(FlashCardsSVG, "FlashCards");
export const HundredsChart = createCustomIcon(HundredsChartSVG, "HundredsChart");
export const MAB = createCustomIcon(MABSVG, "MAB");
export const NameGenerator = createCustomIcon(NameGeneratorSVG, "NameGenerator");
export const NoiseMeter = createCustomIcon(NoiseMeterSVG, "NoiseMeter");
export const NumberLine = createCustomIcon(NumberLineSVG, "NumberLine");
export const PlaceValueMat = createCustomIcon(PlaceValueMatSVG, "PlaceValueMat");
export const SpinWheel = createCustomIcon(SpinWheelSVG, "SpinWheel");
export const Timer = createCustomIcon(TimerSVG, "Timer");
export const WellnessCheckin = createCustomIcon(WellnessCheckinSVG, "WellnessCheckin");
export const WordBuilder = createCustomIcon(WordBuilderSVG, "WordBuilder");
export const Stopwatch = createCustomIcon(StopwatchSVG, "Stopwatch");
export const Embed = createCustomIcon(EmbedSVG, "Embed");
export const FreeText = createCustomIcon(FreeTextSVG, "FreeText");
export const Schedule = createCustomIcon(ScheduleSVG, "Schedule");
export const GoogleSlides = createCustomIcon(GoogleSlidesSVG, "GoogleSlides");
export const Youtube = createCustomIcon(YoutubeSVG, "Youtube");
export const ImageWidgetSVG = createCustomIcon(ImageSVG, "Image");
export const CarTesian = createCustomIcon(CartesianSVG, "Cartesian");
export const Boggle = createCustomIcon(BoggleSVG, "Boggle");
export const NoggleIcon = createCustomIcon(NoggleSVG, "Noggle");
export const MoneyIcon = createCustomIcon(Money, "Money");
